import { Button, Dialog, DialogActions, TextField } from "@mui/material";
import StaticDatePicker from "@mui/lab/StaticDatePicker";

const DialogPicker = (props) => {
  const { date, format, open = false, setOpen, onChange } = props;

  const selectDate = (date) => {
    onChange(date);
    setOpen(false);
  };
  const textInput = () => <TextField style={{ display: "none" }} />;

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <StaticDatePicker
        displayStaticWrapperAs="desktop"
        openTo="day"
        orientation="landscape"
        value={date}
        format={format}
        onChange={() => {}}
        onAccept={(date) => selectDate(date)}
        TextFieldComponent={textInput}
        renderInput={() => <></>}
      />
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Zatvori</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogPicker;
